<app-header></app-header>

<div class="container">
  <div class="tile-grid">
    <div *ngFor="let client of clients" class="tile" (click)="navigateToHome()">
      <span>{{ client }}</span>
    </div>
  </div>
</div>

<app-footer></app-footer>
